"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShippingOfferInDeliveryStep = useShippingOfferInDeliveryStep;
var _shippingOfferDialogResult = require("@ori-events/shipping-offer-dialog-result");
var ShowShippingOfferDialog = _interopRequireWildcard(require("@ori-events/show-shipping-offer-dialog"));
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _logger = require("../logger");
var _models = require("../models");
var _utils = require("../utils");
var _useNextStepNavigation = require("./useNextStepNavigation");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function useShippingOfferInDeliveryStep(deliveryChannelId, mutateSelectedDelivery) {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const shippingOfferTestId = getTestId(_models.TestId.ShippingOffer);
  const [isShippingOfferDialogOpen, setIsShippingOfferDialogOpen] = (0, _react.useState)(false);
  const {
    setWasNavigationToNextStep,
    wasNavigationToNextStep
  } = (0, _useNextStepNavigation.useNextStepNavigation)();
  (0, _react.useEffect)(() => {
    function openShippingOfferDialogNextStep() {
      setWasNavigationToNextStep(true);
      setIsShippingOfferDialogOpen(true);
      // analytics
      // In this case, one of the couriers in page has to be selected & there should
      // be displayed the shipping offer banner close to it. Let's find the banner first
      // and then the closest wrapper element with the courier name in its dataset.
      const shippingOfferElement = document.querySelector(`[data-testid=${shippingOfferTestId}]`);
      const metaData = [_models.MetaHierarchy.ShippingOfferSelection, _models.MetaHierarchy.AutomaticallyTriggered];
      const courierName = (0, _utils.getCourierNameFromElement)(shippingOfferElement);
      if (courierName) {
        metaData.push(courierName);
      }
      (0, _utils.dispatchUserActionEvent)(metaData);
    }
    window.addEventListener(ShowShippingOfferDialog.Name, openShippingOfferDialogNextStep);
    return () => {
      window.removeEventListener(ShowShippingOfferDialog.Name, openShippingOfferDialogNextStep);
    };
  });
  const onShippingOfferBannerClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    setIsShippingOfferDialogOpen(true);
    // analytics
    const metaData = [_models.MetaHierarchy.ShippingOfferSelection, _models.MetaHierarchy.TriggeredFromDeliveryCard];
    const courierName = (0, _utils.getCourierNameFromElement)(event.target);
    if (courierName) {
      metaData.push(courierName);
    }
    (0, _utils.dispatchUserActionEvent)(metaData);
  }, [setIsShippingOfferDialogOpen]);
  const handleCloseDialog = (0, _react.useCallback)((_, reason) => {
    (0, _logger.logDebug)('Shipping dialog close handler was called. Reason:', reason);
    setIsShippingOfferDialogOpen(false);
    if (wasNavigationToNextStep) {
      // dispatch result event for legacy code only when navigating to next step
      // success result event was already dispatched in another place,
      // and on error the dialog should stay open, so just cancel result solved here
      if (reason !== 'success') {
        (0, _utils.dispachShippingOfferDialogResultEvent)({
          result: _shippingOfferDialogResult.Result.Cancel
        });
        // analytics
        (0, _utils.dispatchUserActionEvent)([_models.MetaHierarchy.ShippingOfferSelection, _models.MetaHierarchy.SkippedByUser]);
      }
      setWasNavigationToNextStep(false);
    } else if (reason === 'success') {
      // refresh displayed delivery step data only on success
      void mutateSelectedDelivery();
    }
  }, [mutateSelectedDelivery, setWasNavigationToNextStep, wasNavigationToNextStep]);
  const shippingOfferDialogProps = {
    deliveryChannelId,
    isOpen: isShippingOfferDialogOpen,
    onClose: handleCloseDialog
  };
  return {
    isShippingOfferDialogOpen,
    onShippingOfferBannerClick,
    setIsShippingOfferDialogOpen,
    shippingOfferDialogProps
  };
}